<template>
  <ParkingPublicPayment />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ParkingPublicPayment from "../../components/Parking/ParkingPublicPayment.vue";

export default defineComponent({
  name: "ParkingPaymentPage",
  components: {
    ParkingPublicPayment,
  },
});
</script>
